import type { SearchIndex } from 'algoliasearch/lite';
import algoliasearch from 'algoliasearch/lite';

let algoliaIndex: SearchIndex;

/**
 *
 * Returns an Algolia search index instance.
 *
 * @param {string} algoliaAppId - The Algolia application ID.
 * @param {string} algoliaApiKey - The Algolia API key.
 * @returns {SearchIndex} The Algolia search index instance.
 */
export function getAlgoliaIndex({
  algoliaAppId,
  algoliaApiKey,
  index = 'companies-dev',
}: {
  algoliaAppId: string;
  algoliaApiKey: string;
  index: 'companies-dev' | 'companies';
}) {
  if (typeof algoliaIndex === 'undefined') {
    const algo = algoliasearch(algoliaAppId, algoliaApiKey);
    algoliaIndex = algo.initIndex(index);
  }
  return algoliaIndex;
}
